import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

// Components
import Button from '@components/actions/button';
import PlusIcon from '@components/basics/icons/plus';
import Typography from '@components/basics/typography';
import RosterMenu from '@webapp/controllers/menus/roster-menu';

interface ComponentNameProps {
  className?: string;
  hasLabels?: boolean;
}

const CreateRoster: FunctionComponent<ComponentNameProps> = ({
  className,
  hasLabels,
}) => {
  return (
    <CreateRosterContainer
      className={`${className || ''} ${hasLabels ? 'has-labels' : ''}`}
    >
      <Wrapper>
        <GreyCircle />
        <Typography type="big-title">
          <Translate id="USER_PROFILE.ROSTER.NEW_ROSTER.TITLE" />
        </Typography>
      </Wrapper>
      <RosterMenu
        action={
          <>
            <AddButton className="add-button">
              <PlusIcon className="plus-icon" noAnimation />
            </AddButton>
            <Button className="button" buttonType="primary">
              <Translate id="USER_PROFILE.ROSTER.NEW_ROSTER.BUTTON" />
            </Button>
          </>
        }
      />
    </CreateRosterContainer>
  );
};

export default styled(CreateRoster)`
  .add-button {
    display: flex;
    @media ${({ theme }) => theme.device.laptopL} {
      display: none;
    }
  }
  .button {
    display: none;
    @media ${({ theme }) => theme.device.laptopL} {
      display: block;
    }
  }
  margin-bottom: 10px;
`;

const CreateRosterContainer = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  border: 1px dashed ${({ theme }) => theme.colors.border};

  &.has-labels {
    border-radius: 10px 10px 0px 0px;
  }

  @media ${({ theme }) => theme.device.tablet} {
    padding: 30px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const GreyCircle = styled.div`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  flex-grow: 0;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.secondary};
`;

const AddButton = styled.button`
  cursor: pointer;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.accent};
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  .plus-icon {
    width: 12px;
    height: 12px;
    path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  &:hover,
  &:active {
    background-color: ${({ theme }) => theme.colors.accentHover};
  }

  &.disabled {
    pointer-events: none;
    background-color: ${({ theme }) => theme.colors.secondary};

    .plus-icon {
      path {
        fill: ${({ theme }) => theme.colors.tertiary};
      }
    }
  }
`;
